type MaintenanceConfig = {
  enabled: boolean;
  title?: string;
  message?: string;
  eyebrow?: string;
  contactEmail?: string;
  expectedBackAt?: string;
  allowedIps?: string[];
};

const fallback: MaintenanceConfig = { enabled: false };

export async function readMaintenanceConfig(): Promise<MaintenanceConfig> {
  // La configurazione gestita dal backoffice è la fonte autorevole e deve
  // avere effetto immediato, senza attendere una nuova build dello storefront.
  try {
    const apiBase = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';
    const status = await fetch(`${apiBase}/api/maintenance/status?t=${Date.now()}`, { cache: 'no-store' });
    if (status.ok) return { ...fallback, ...await status.json() as MaintenanceConfig };
  } catch { /* usa il file statico di emergenza */ }

  try {
    const response = await fetch(`/maintenance.json?t=${Date.now()}`, { cache: 'no-store' });
    if (response.ok) return { ...fallback, ...await response.json() as MaintenanceConfig };
  } catch { /* un errore totale non deve bloccare un negozio sano */ }
  return fallback;
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]!);
}

export function renderMaintenance(config: MaintenanceConfig): void {
  const root = document.getElementById('root');
  if (!root) return;
  document.title = `${config.title ?? 'Sito in manutenzione'} | Enoteca La Brocca`;
  const contact = config.contactEmail
    ? `<a class="maintenance-contact" href="mailto:${encodeURIComponent(config.contactEmail)}">${escapeHtml(config.contactEmail)}</a>`
    : '';
  const returnTime = config.expectedBackAt
    ? `<p class="maintenance-return">Ritorno previsto: <strong>${escapeHtml(config.expectedBackAt)}</strong></p>`
    : '';
  root.innerHTML = `
    <main class="maintenance-page">
      <div class="maintenance-glow" aria-hidden="true"></div>
      <section class="maintenance-card" aria-labelledby="maintenance-title">
        <img class="maintenance-mark" src="/favicon.svg" alt="" width="72" height="72">
        <p class="maintenance-eyebrow">${escapeHtml(config.eyebrow ?? 'Enoteca La Brocca · dal 1978')}</p>
        <h1 id="maintenance-title">${escapeHtml(config.title ?? 'Stiamo preparando qualcosa di speciale')}</h1>
        <p class="maintenance-message">${escapeHtml(config.message ?? 'Il sito è momentaneamente in manutenzione. Torneremo presto.')}</p>
        ${returnTime}${contact}
        <div class="maintenance-rule" aria-hidden="true"><span></span></div>
        <p class="maintenance-note">Grazie per la pazienza. La qualità richiede il giusto tempo.</p>
      </section>
    </main>`;
}
